<app-component-header></app-component-header>

<div class="component-block">

    <section class="block scb-bg pdb30">
        <div class="container">
            <div class="row">
            </div>
        </div>
    </section>
    <section class="block-formControlWrap">
        <div class="container">
            <div class="row">
                <div class="margin-bottom-5">
                    <div class="col-xs-6">
                        <div class="page-head">
                            <div class="page-title">

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="block-formControl">
                        <div class="section-title-wrapper">
                            <span class="section-title">
                                Xác nhận email từ khách hàng
                            </span>
                        </div>
                        <div class="section">
                            <div class="text-center">
                                <img src="assets/img/email/mailrefuse.png" style="width:20%;" />
                                <h3>Xác nhận từ chối nhận email.</h3>
                                <span>
                                    SACOMBANK đã nhận được yêu cầu từ chối nhận quảng cáo của Quý khách hàng và sẽ
                                    dừng gửi thông tin quảng cáo qua email của Quý khách hàng từ
                                    {{hour}} giờ {{minute}} phút ngày
                                    {{ now | date : "dd/MM/yyyy"}}.
                                    Để cập nhật thông tin mới nhất về chương trình khuyến mại, sản phẩm, dịch vụ,
                                    vui lòng liên hệ (i) địa điểm giao dịch SACOMBANK (ii) truy cập website
                                    www.sacombank.com.vn (iii) tổng đài 1900.5555.88.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>

<app-component-footer></app-component-footer>